import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Scroll, Ripple, ClickOutside, Intersect } from "vuetify/lib/directives"
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

// Importaciones de iconos de Lucide
import ChevronDown from "/node_modules/lucide-vue/dist/esm/icons/chevron-down.js"
import ChessQueen from "/node_modules/lucide-vue/dist/esm/icons/chess-queen.js"
import BookOpen from "/node_modules/lucide-vue/dist/esm/icons/book-open.js"
import Palette from "/node_modules/lucide-vue/dist/esm/icons/palette.js"
import Smartphone from "/node_modules/lucide-vue/dist/esm/icons/smartphone.js"
import Cpu from "/node_modules/lucide-vue/dist/esm/icons/cpu.js"
import Rocket from "/node_modules/lucide-vue/dist/esm/icons/rocket.js"
import Flask from "/node_modules/lucide-vue/dist/esm/icons/flask-conical.js"
import Box from "/node_modules/lucide-vue/dist/esm/icons/box.js"
import Music from "/node_modules/lucide-vue/dist/esm/icons/music.js"
import Camera from "/node_modules/lucide-vue/dist/esm/icons/camera.js"
import Wand from "/node_modules/lucide-vue/dist/esm/icons/wand.js"
import Clapperboard from "/node_modules/lucide-vue/dist/esm/icons/clapperboard.js"
import DollarSign from "/node_modules/lucide-vue/dist/esm/icons/dollar-sign.js"
import Globe from "/node_modules/lucide-vue/dist/esm/icons/globe.js"
import AlphaA from "/node_modules/lucide-vue/dist/esm/icons/type.js"
import Skull from "/node_modules/lucide-vue/dist/esm/icons/skull.js"
import Wind from "/node_modules/lucide-vue/dist/esm/icons/wind.js"
import Pillar from "/node_modules/lucide-vue/dist/esm/icons/columns.js"
import BarChart from "/node_modules/lucide-vue/dist/esm/icons/bar-chart.js"
import Brush from "/node_modules/lucide-vue/dist/esm/icons/brush.js"
import Croissant from "/node_modules/lucide-vue/dist/esm/icons/croissant.js"
import Coffee from "/node_modules/lucide-vue/dist/esm/icons/coffee.js"
import Lightbulb from "/node_modules/lucide-vue/dist/esm/icons/lightbulb.js"
import Library from "/node_modules/lucide-vue/dist/esm/icons/library.js"
import Dancing from "/node_modules/lucide-vue/dist/esm/icons/venetian-mask.js"
import Network from "/node_modules/lucide-vue/dist/esm/icons/network.js"
import Search from "/node_modules/lucide-vue/dist/esm/icons/search.js"
import Check from "/node_modules/lucide-vue/dist/esm/icons/check.js"
import X from "/node_modules/lucide-vue/dist/esm/icons/x.js"
import Trash from "/node_modules/lucide-vue/dist/esm/icons/trash.js"
import CheckCircle from "/node_modules/lucide-vue/dist/esm/icons/check-circle.js"
import Info from "/node_modules/lucide-vue/dist/esm/icons/info.js"
import AlertTriangle from "/node_modules/lucide-vue/dist/esm/icons/alert-triangle.js"
import AlertCircle from "/node_modules/lucide-vue/dist/esm/icons/alert-circle.js"
import ChevronLeft from "/node_modules/lucide-vue/dist/esm/icons/chevron-left.js"
import ChevronRight from "/node_modules/lucide-vue/dist/esm/icons/chevron-right.js"
import Square from "/node_modules/lucide-vue/dist/esm/icons/square.js"
import CheckSquare from "/node_modules/lucide-vue/dist/esm/icons/check-square.js"
import Menu from "/node_modules/lucide-vue/dist/esm/icons/menu.js"
import Radio from "/node_modules/lucide-vue/dist/esm/icons/radio.js"
import Pencil from "/node_modules/lucide-vue/dist/esm/icons/pencil.js"
import Star from "/node_modules/lucide-vue/dist/esm/icons/star.js"
import StarHalf from "/node_modules/lucide-vue/dist/esm/icons/star-half.js"
import StarOff from "/node_modules/lucide-vue/dist/esm/icons/star-off.js"
import Loader from "/node_modules/lucide-vue/dist/esm/icons/loader.js"
import ChevronsLeft from "/node_modules/lucide-vue/dist/esm/icons/chevrons-left.js"
import ChevronsRight from "/node_modules/lucide-vue/dist/esm/icons/chevrons-right.js"
import MinusSquare from "/node_modules/lucide-vue/dist/esm/icons/minus-square.js"
import File from "/node_modules/lucide-vue/dist/esm/icons/file.js"
import Plus from "/node_modules/lucide-vue/dist/esm/icons/plus.js"
import Minus from "/node_modules/lucide-vue/dist/esm/icons/minus.js"
import ArrowLeft from "/node_modules/lucide-vue/dist/esm/icons/arrow-left.js"
import Layers from "/node_modules/lucide-vue/dist/esm/icons/layers.js"
import Square from "/node_modules/lucide-vue/dist/esm/icons/square.js"
import { HelpCircle, 
  Clipboard,
  CircleCheckBig
 } from 'lucide-vue'

 import { mdiCheckCircleOutline, mdiCircleOutline } from '/src/assets/mdi.json'


Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'lucide',
    values: {
      "magnify": {
        component: Search,
        props: { size: 20 }
      },
      "mdi-book-open-variant": {
        component: BookOpen,
        props: { size: 20 }
      },
      "mdi-chevron-left": {
        component: ChevronLeft,
        props: { size: 20 }
      },
      "mdi-chevron-right": {
        component: ChevronRight,
        props: { size: 20 }
      },
      "mdi-arrow-left": {
        component: ArrowLeft,
        props: { size: 20 }
      },
      "mdi-image-filter-vintage": {
        component: Palette,
        props: { size: 20 }
      },
      "mdi-android-studio": {
        component: Smartphone,
        props: { size: 20 }
      },
      "mdi-chip": {
        component: Cpu,
        props: { size: 20 }
      },
      "mdi-rocket": {
        component: Rocket,
        props: { size: 20 }
      },
      "mdi-flask-empty": {
        component: Flask,
        props: { size: 20 }
      },
      "mdi-pi-box": {
        component: Box,
        props: { size: 20 }
      },
      "mdi-music": {
        component: Music,
        props: { size: 20 }
      },
      "mdi-camera-image": {
        component: Camera,
        props: { size: 20 }
      },
      "mdi-auto-fix": {
        component: Wand,
        props: { size: 20 }
      },
      "mdi-palette": {
        component: Palette,
        props: { size: 20 }
      },
      "mdi-movie-open": {
        component: Clapperboard,
        props: { size: 20 }
      },
      "mdi-currency-usd": {
        component: DollarSign,
        props: { size: 20 }
      },
      "mdi-earth": {
        component: Globe,
        props: { size: 20 }
      },
      "mdi-alpha": {
        component: AlphaA,
        props: { size: 20 }
      },
      "mdi-skull-outline": {
        component: Skull,
        props: { size: 20 }
      },
      "mdi-wind-turbine": {
        component: Wind,
        props: { size: 20 }
      },
      "mdi-pillar": {
        component: Pillar,
        props: { size: 20 }
      },
      "mdi-equalizer": {
        component: BarChart,
        props: { size: 20 }
      },
      "mdi-brush": {
        component: Brush,
        props: { size: 20 }
      },
      "mdi-food-croissant": {
        component: Croissant,
        props: { size: 20 }
      },
      "mdi-glass-mug-variant": {
        component: Coffee,
        props: { size: 20 }
      },
      "mdi-lightbulb-on-outline": {
        component: Lightbulb,
        props: { size: 20 }
      },
      "mdi-bookshelf": {
        component: Library,
        props: { size: 20 }
      },
      "mdi-dance-ballroom": {
        component: Dancing,
        props: { size: 20 }
      },
      "mdi-web": {
        component: Network,
        props: { size: 20 }
      },
      "mdi-magnify": {
        component: Search,
        props: { size: 20 }
      },
      "mdi-help-circle-outline": {
        component: HelpCircle,
        props: { size: 20 }
      },
      "mdi-clipboard-text-outline": {
        component: Clipboard,
        props: { size: 20 }
      },
     
      // Vuetify
      "complete": {
        component: Check,
        props: { size: 20 }
      },
      "cancel": {
        component: X,
        props: { size: 20 }
      },
      "sort": {
        component: ChevronDown,
        props: { size: 20 }
      },
      "close": {
        component: X,
        props: { size: 20 }
      },
      "delete": {
        component: Trash,
        props: { size: 20 }
      },
      "clear": {
        component: X,
        props: { size: 20 }
      },
      "success": {
        component: CheckCircle,
        props: { size: 20 }
      },
      "info": {
        component: Info,
        props: { size: 20 }
      },
      "warning": {
        component: AlertTriangle,
        props: { size: 20 }
      },
      "error": {
        component: AlertCircle,
        props: { size: 20 }
      },
      "prev": {
        component: ChevronLeft,
        props: { size: 20 }
      },
      "next": {
        component: ChevronRight,
        props: { size: 20 }
      },
      "checkboxOn": {
        component: CheckSquare,
        props: { size: 20 }
      },
      "checkboxOff": {
        component: Square,
        props: { size: 20 }
      },
      "checkboxIndeterminate": {
        component: MinusSquare,
        props: { size: 20 }
      },
      "sort": `M6,5H18A1,1 0 0,1 19,6A1,1 0 0,1 18,7H6A1,1 0 0,1 5,6A1,1 0 0,1 6,5M21,2V4H3V2H21M15,8H17V22H15V8M7,8H9V22H7V8M11,8H13V22H11V8Z`,
      "expand": {
        component: ChevronDown,
        props: { size: 20 }
      },
      "subgroup": {
        component: ChevronDown,
        props: { size: 20 }
      },
      "search": {
        component: Search,
        props: { size: 20 }
      },
      "menu": {
        component: Menu,
        props: { size: 20 }
      },
      "dropdown": {
        component: ChevronDown,
        props: { size: 20 }
      },
      "radioOn": mdiCheckCircleOutline,
      "radioOff": mdiCircleOutline,
      "edit": {
        component: Pencil,
        props: { size: 20 }
      },
      "ratingEmpty": "M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
      "ratingFull": "M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z",
      "ratingHalf": "M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
      "loading": {
        component: Loader,
        props: { size: 20 }
      },
      "first": {
        component: ChevronsLeft,
        props: { size: 20 }
      },
      "last": {
        component: ChevronsRight,
        props: { size: 20 }
      },
      "unfold": {
        component: MinusSquare,
        props: { size: 20 }
      },
      "file": {
        component: File,
        props: { size: 20 }
      },
      "plus": {
        component: Plus,
        props: { size: 20 }
      },
      "minus": {
        component: Minus,
        props: { size: 20 }
      },
      "layers": {
        component: Layers,
        props: { size: 20 }
      },
      "mdi-cards-outline": {
        component: Layers,
        props: { size: 20 }
      },
    }
  },
  theme: {
    dark: false, // valor inicial
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        background: '#FFFFFF',
        text: '#0c193a',
        border: '#D1D5DB',
        primary: '#4dd453',    // Verde principal de Duolingo
        secondary: '#1cb0f6',  // Azul de Duolingo
        accent: '#ce82ff',     // Morado de Duolingo
        error: '#ff4b4b',      // Rojo de Duolingo
        warning: '#ff9600',    // Naranja de Duolingo
        info: '#1cb0f6',       // Azul de Duolingo
        success: '#58cc02'     // Verde de Duolingo
        // ... altres colors
      },
      dark: {
        primary: '#4dd453',
        background: '#1E1E1E',
        text: '#FFFFFF',
        border: '#363636',
        // ... altres colors pel tema fosc
      }
    }
  },
  directives: {
    Ripple,
    Scroll,
    ClickOutside,
    Intersect
  }
}) 